import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReservationService } from 'src/app/services/reservation/reservation.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';
@Component({
  selector: 'app-add-offers-modal',
  templateUrl: './add-offers-modal.component.html',
  styleUrls: ['./add-offers-modal.component.scss']
})
export class AddOffersModalComponent {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() title: string;
  @Input() modalType: string;
  @Input() modalDataID: string;
  @Input() routeName: string;
  @Input() clickedBrandId: string;
  @Input() shopId: string;
  @Output() offerAction = new EventEmitter();
  @Output() cancelAction = new EventEmitter();
  // @Output() brandFunction = new EventEmitter<{ int: any, routeName: any }>();
  submitted: any = false
  brand: any = false
  isSuccess: any = false
  loading: any = false
  formMessage: any = ''
  selectedStartDate: string = moment().format('YYYY-MM-DD');
  selectedExpireyDate: string = moment().format('YYYY-MM-DD');
  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private reservationService: ReservationService,
  ) {
  }


  ngOnChanges(changes: SimpleChanges) {
    console.log(this.modalDataID, 'modalData', changes, this.shopId);
    this.offerForm.reset();
    this.offerForm.patchValue({ shop_id: this.shopId })
    if (this.modalDataID != '') {
      this.getOfferData();
    } else {
      console.log('clear');

      this.clearForms()
    }


  }

  offerForm: FormGroup = new FormGroup({
    id: new FormControl(''),
    shop_id: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    from: new FormControl('', [Validators.required]),
    to: new FormControl('', [Validators.required]),
    value_type: new FormControl(''),

  })

  get setOfferControls() { return this.offerForm.controls; }

  getOfferData() {

    this.reservationService.getOffer(this.modalDataID)
      .subscribe({
        next: (res) => {
          this.offerForm.patchValue(res.data)
        },
        error: (error) => {
          console.log(error);

        }
      })
  }

  onAddClick() {
    this.submitted = true
    if (this.offerForm.valid) {

      this.offerForm.patchValue({
        from: moment(this.offerForm.value.from).format('YYYY-MM-DD'),
        to: moment(this.offerForm.value.to).format('YYYY-MM-DD')
      })



      this.reservationService.createOffer(this.offerForm.value)
        .subscribe({
          next: (res) => {
            this.submitted = false
            this.offerAction.emit()
          },
          error: (error) => {
            console.log(error);
            this.formMessage = error;
          }
        })
    } else {
      this.formMessage = 'Please fill all required fields!';
    }

  }

  onEditClick() {
    this.submitted = true
    if (this.offerForm.valid) {
      const formData = new FormData();
      formData.append('shop_id', this.offerForm.value.shop_id)
      formData.append('name', this.offerForm.value.name)
      formData.append('description', this.offerForm.value.description)
      formData.append('value', this.offerForm.value.value)
      formData.append('from', moment(this.offerForm.value.from).format('YYYY-MM-DD'))
      formData.append('to', moment(this.offerForm.value.to).format('YYYY-MM-DD'))
      formData.append('_method', 'put');

      this.reservationService.updateOffer(this.modalDataID, formData)
        .subscribe({
          next: (res) => {
            this.submitted = false
            this.offerAction.emit()
          },
          error: (error) => {
            console.log(error);

          }
        })
    } else {
      this.formMessage = 'Please fill all required fields!';
    }
  }

  clearForms() {
    this.submitted = false
    this.offerForm.removeControl('name');
    this.offerForm.removeControl('description');
    this.offerForm.removeControl('value');
    this.offerForm.removeControl('from');
    this.offerForm.removeControl('to');

    this.offerForm.addControl('name', new FormControl('', [Validators.required]));
    this.offerForm.addControl('description', new FormControl('', [Validators.required]));
    this.offerForm.addControl('value', new FormControl('', [Validators.required]));
    this.offerForm.addControl('from', new FormControl('', [Validators.required]));
    this.offerForm.addControl('to', new FormControl('', [Validators.required]));
  }

  onCancelClick() {
    this.offerForm.get('name').clearValidators();
    this.offerForm.get('description').clearValidators();
    this.offerForm.get('value').clearValidators();
    this.offerForm.get('from').clearValidators();
    this.offerForm.get('to').clearValidators();
    this.clearForms()
    this.cancelAction.emit()
  }
}
